import { type DatoTargetBlock } from '@/lib/datocms';

const ENTERPRISE_HOST = 'enterprise.ironhack.com';

const isEnterpriseIronhackUrl = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return (
      hostname === ENTERPRISE_HOST || hostname.endsWith(`.${ENTERPRISE_HOST}`)
    );
  } catch {
    return url.includes(ENTERPRISE_HOST);
  }
};

/** Footer columns 2–3 use nofollow by default; enterprise links should stay followed. */
export const getFooterColumnRelForTarget = (
  target: DatoTargetBlock,
  { noFollow }: { noFollow?: boolean }
): string | undefined => {
  if (target.link && isEnterpriseIronhackUrl(target.link)) {
    return 'noopener';
  }
  if (noFollow) {
    return 'nofollow';
  }
};
